import React from "react";
import IndiaDisclaimerAlert from "components/shared/alerts/IndiaDisclaimerAlert";
import { Header } from "components/shared/Header";
import useInternationalization from "hooks/useInternationalization";
import { PageContent } from "components/shared/PageContent";

function PageContainer({ children }: { children: any }) {
  const { visitorIsFromIndia } = useInternationalization();

  return (
    <>
      <IndiaDisclaimerAlert visitorIsFromIndia={visitorIsFromIndia} />
      <div className="flex flex-col w-screen">
        <Header />
        <PageContent>{children}</PageContent>
      </div>
    </>
  );
}

export default PageContainer;
